/**
 * Makes every rate id unique within its room type. The API can return the same
 * rate id twice (one row per occupancy variant) and the cart keys off that id,
 * so without this a guest adding the second row would mutate the first.
 * The untouched id stays on id_ori for the booking payload.
 * @param {Object} roomType a room type from search-room
 * @returns {Object} the same object, with room_rate ids rewritten
 */
export function withIndexedRateIds(roomType) {
  roomType.room_rate = roomType.room_rate.map((roomRate, roomRateIndex) => {
    const originalId = roomRate.id;
    roomRate.id_ori = originalId;
    roomRate.id = `${originalId}_${roomRateIndex}`;
    return roomRate;
  });
  return roomType;
}



// WEBPACK FOOTER //
// ./src/utils/beRoomType.js